import DragIndicatorIcon from "@mui/icons-material/DragIndicatorRounded";
import { ListItemIcon } from "@mui/material";
import FolderOpenSymbolIcon from "@entrilia/shared/icons/FolderOpenSymbolIcon.tsx";
import FolderSymbolIcon from "@entrilia/shared/icons/FolderSymbolIcon.tsx";

const ICON_SIZE_PX = 18;

interface Props {
  open: boolean;
  dragHandle?: boolean;
}

const GroupFolderIcon = ({ open, dragHandle }: Props) => {
  const FolderGlyph = open ? FolderOpenSymbolIcon : FolderSymbolIcon;
  const sx = { width: ICON_SIZE_PX, height: ICON_SIZE_PX };

  return (
    <ListItemIcon sx={{ minWidth: "20px", ml: 0.25, mr: 0.75, justifyContent: "center" }}>
      {dragHandle ? <DragIndicatorIcon sx={sx} /> : <FolderGlyph sx={sx} />}
    </ListItemIcon>
  );
};

export default GroupFolderIcon;
